import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0c40efe2"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "receipt-container",
  ref: "receiptContainer",
  style: {"margin-top":"10px"}
}
const _hoisted_2 = { class: "center" }
const _hoisted_3 = { class: "center" }
const _hoisted_4 = { class: "center" }
const _hoisted_5 = { class: "center" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "divider" }, null, -1))
const _hoisted_7 = { class: "left" }
const _hoisted_8 = { class: "left" }
const _hoisted_9 = { class: "bold double-height center" }
const _hoisted_10 = { class: "left" }
const _hoisted_11 = { class: "left" }
const _hoisted_12 = { class: "left" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "underline bold center double-height" }, "Items", -1))
const _hoisted_14 = { class: "item" }
const _hoisted_15 = { class: "item-name" }
const _hoisted_16 = { class: "breakable-text" }
const _hoisted_17 = { class: "unit-price" }
const _hoisted_18 = { class: "item-total" }
const _hoisted_19 = { class: "generic-name" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "divider" }, null, -1))
const _hoisted_21 = { class: "span" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "span-label bold" }, "Subtotal: ", -1))
const _hoisted_23 = { class: "span-amount bold" }
const _hoisted_24 = { class: "span" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "span-label" }, "Total Discount: ", -1))
const _hoisted_26 = { class: "span-amount" }
const _hoisted_27 = { class: "span" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "span-label" }, "Total Tax: ", -1))
const _hoisted_29 = { class: "span-amount" }
const _hoisted_30 = { class: "span" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "span-label bold large-size" }, "Total: ", -1))
const _hoisted_32 = { class: "span-amount bold large-size" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "center" }, "Transaction details:", -1))
const _hoisted_34 = { class: "full-width-table font-size-normal" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "left td" }, "Payment Type:", -1))
const _hoisted_36 = {
  class: "center td nowrap",
  style: {"padding-right":"152px"}
}
const _hoisted_37 = {
  class: "font-size-normal",
  style: {"margin-left":"auto"}
}
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "right font-size-normal" }, "Total Paid:", -1))
const _hoisted_39 = { class: "right nowrap font-size-normal" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "right" }, "Total Change:", -1))
const _hoisted_41 = { class: "right nowrap" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "divider" }, null, -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "footer center bold" }, "Powered by Doc990", -1))
const _hoisted_44 = { class: "print-container" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "company-logo" }, [
  /*#__PURE__*/_createElementVNode("img", {
    style: {"width":"100px","height":"auto"},
    src: "https://printer-template-images.s3.ap-southeast-1.amazonaws.com/Images/New-Logo.png",
    class: "logo-img"
  })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.receiptInfo.branch_name), 1),
      _createElementVNode("div", _hoisted_3, "Address: " + _toDisplayString(_ctx.receiptInfo.address), 1),
      _createElementVNode("div", _hoisted_4, "License No: " + _toDisplayString(_ctx.receiptInfo.licenseNo), 1),
      _createElementVNode("div", _hoisted_5, "Tel: " + _toDisplayString(_ctx.receiptInfo.telephone), 1),
      _hoisted_6,
      _createElementVNode("div", _hoisted_7, "Receipt: #" + _toDisplayString(_ctx.receiptInfo.receipt_no), 1),
      _createElementVNode("div", _hoisted_8, "Type: " + _toDisplayString(_ctx.receiptInfo.type), 1),
      _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.receiptInfo.customerName), 1),
      _createElementVNode("div", _hoisted_10, "Tel: " + _toDisplayString(_ctx.receiptInfo.msisdn), 1),
      _createElementVNode("div", _hoisted_11, "Date/Time: " + _toDisplayString(_ctx.receiptInfo.date_time), 1),
      _createElementVNode("div", _hoisted_12, "Associate: " + _toDisplayString(_ctx.receiptInfo.empId), 1),
      _hoisted_13,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.receiptInfo.items, (item, index) => {
        return (_openBlock(), _createElementBlock("div", { key: index }, [
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("span", _hoisted_15, [
              _createElementVNode("span", _hoisted_16, _toDisplayString(item.item_name), 1)
            ]),
            _createElementVNode("span", _hoisted_17, _toDisplayString(item.total_unit) + " x " + _toDisplayString(item.mrp), 1),
            _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.currency) + _toDisplayString(Number(item.total_unit) * Number(item.mrp)), 1)
          ]),
          _createElementVNode("div", _hoisted_19, "(" + _toDisplayString(item.generic_name || 'N/A') + ")", 1),
          _hoisted_20
        ]))
      }), 128)),
      _createElementVNode("div", _hoisted_21, [
        _hoisted_22,
        _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.currency) + _toDisplayString(_ctx.receiptInfo.sub_total), 1)
      ]),
      _createElementVNode("div", _hoisted_24, [
        _hoisted_25,
        _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.currency) + _toDisplayString(_ctx.receiptInfo.total_discount), 1)
      ]),
      _createElementVNode("div", _hoisted_27, [
        _hoisted_28,
        _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.currency) + _toDisplayString(_ctx.receiptInfo.total_tax), 1)
      ]),
      _createElementVNode("div", _hoisted_30, [
        _hoisted_31,
        _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.currency) + _toDisplayString(_ctx.receiptInfo.total), 1)
      ]),
      _hoisted_33,
      _createElementVNode("div", null, [
        _createElementVNode("table", _hoisted_34, [
          _createElementVNode("tr", null, [
            _hoisted_35,
            _createElementVNode("td", _hoisted_36, _toDisplayString(_ctx.receiptInfo.payment_type), 1)
          ])
        ])
      ]),
      _createElementVNode("table", _hoisted_37, [
        _createElementVNode("tr", null, [
          _hoisted_38,
          _createElementVNode("td", _hoisted_39, _toDisplayString(_ctx.currency) + _toDisplayString(_ctx.receiptInfo.tendered), 1)
        ]),
        _createElementVNode("tr", null, [
          _hoisted_40,
          _createElementVNode("td", _hoisted_41, _toDisplayString(_ctx.currency) + _toDisplayString(_ctx.receiptInfo.change), 1)
        ])
      ]),
      _hoisted_42,
      _hoisted_43
    ], 512),
    _createElementVNode("div", _hoisted_44, [
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.printReceipt && _ctx.printReceipt(...args))),
        class: "print-button"
      }, "Print Receipt"),
      _hoisted_45
    ])
  ]))
}